import { useFirebaseContext } from '../lib/context/Firebase';
import { useAppDispatch } from '../lib/hooks';
import { logout } from '../lib/model/user/userSlice';
import { PropsWithChildren, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';

export default function AuthState(props: PropsWithChildren) {
    const firebase = useFirebaseContext();
    const dispatch = useAppDispatch();

    // firebase.auth.currentUser is null synchronously right after getAuth() returns, until the
    // SDK finishes restoring a persisted session from IndexedDB - reading it directly (as this
    // used to) treats "not resolved yet" the same as "signed out" and dispatches logout() on
    // every fresh page load, even for a user with a perfectly valid session. That premature
    // logout is what sent ProtectedRoute back to /login on a page a user was already signed in
    // to, which combined with Login.tsx's redirect-flow spinner (fixed alongside this) is what
    // made returning to the app after a while look like a hang. useAuthState's `loading` flag
    // waits for the real onAuthStateChanged resolution instead of guessing from a race.
    const [user, loading] = useAuthState(firebase.auth);

    useEffect(() => {
        if (!loading && user === null) {
            dispatch(logout());
        }
    }, [loading, user, dispatch]);

    return props.children
}
